import React from 'react';
import Header from '../components/header';
import Body from '../components/body';
import Footer from '../components/footer';
import Home from "../views/Home";
import Contact from '../views/contact';
import { 
    BrowserRouter as Router, 
    Route, 
    Link, 
    Switch 
  } from 'react-router-dom';
  import { motion } from "framer-motion";

var div1Scroll = false;


 


const Wrapper = () => {
    return ( 
        <>
        <Header />
      
        <Body />
       
        <Footer />
        </>
     );
}
 
export default Wrapper;